import { IonRouterLink } from '@ionic/react'
import { observer } from 'mobx-react'
import React, { useContext, useEffect } from 'react'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import styled from 'styled-components'
import { PagingContent, TextStyle } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'

export const MainArtMuseum: React.FC = observer(() => {
  const { artfairStore } = useContext(StoresContext)
  const pagingStore = artfairStore.artMuseumPagingStore

  useEffect(() => {
    pagingStore.load(undefined, true)
  }, [])

  return (
    <>
      <MasonryContainer>
        <ResponsiveMasonry columnsCountBreakPoints={{ 350: pagingStore.isLoaded ? 2 : 1 }}>
          <PagingContent pagingStore={pagingStore} emptyText={'조회 가능한 뮤지엄 정보가 없습니다.'}>
            <Masonry columnsCount={2} gutter="16px" style={{ float: 'left' }}>
              {pagingStore.list.map((d, i) => (
                <IonRouterLink key={i} color={'dark'} routerLink={`/artfair/${d.id}`}>
                  <ArticleContainer>
                    <img
                      src={d.imageUri}
                      alt={d.title}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null
                        currentTarget.src = '/img/thumbnail.svg'
                      }}
                    />
                    <TextStyle type={'r_13'}>{d.title}</TextStyle>
                  </ArticleContainer>
                </IonRouterLink>
              ))}
            </Masonry>
          </PagingContent>
        </ResponsiveMasonry>
      </MasonryContainer>
    </>
  )
})

const MasonryContainer = styled.div`
  padding: 20px;
`

const ArticleContainer = styled.div`
  line-height: 17px;
  cursor: pointer;
  img {
    border-radius: 8px;
  }
`
